export default {
    logo: require('../assets/logo.png'),
    icon_close: require('../assets/icon/icon_close.png'),
    icon_company: require('../assets/icon/icon_company.png'),
    icon_mine: require('../assets/icon/icon_mine.png'),
    icon_logo: require('../assets/icon/icon_logo.png'),
    kefu: require('../assets/icon/icon_kefu.png'),
    icon_top_img: require('../assets/icon/icon_top_bg.png'),
    no_link: require('../assets/icon/icon_nolink.png'),
    month: require('../assets/icon/month.png'),
    noMore: require('../assets/icon/no_data.png'),
    ing: require('../assets/icon/icon_ing.png'),
    no_ing: require('../assets/icon/icon_no_ing.png')





}